import { useSelector } from 'react-redux';
import { RootState } from '../app/RootState';
import { roleLevels } from '../constants/Constant';

export const useHighestUserRole = (): { highestRole: string | null; level: number | null } => {
  const reduxRoles = useSelector((state: RootState) => state?.company?.loginRoles);
  const sessionRoles = sessionStorage?.getItem('AllRoles');

  const storedRole = useSelector((state: RootState) => state?.company?.loginRole) || sessionStorage.getItem('Role');

  // If a specific role is set, return that directly
  if (storedRole && storedRole in roleLevels) {
    return {
      highestRole: storedRole,
      level: roleLevels[storedRole],
    };
  }

  // Else, derive highest role from available roles
  let userRoles: string[] = [];

  if (Array.isArray(reduxRoles)) {
    userRoles = reduxRoles;
  } else if (typeof sessionRoles === 'string') {
    try {
      const parsed = JSON.parse(sessionRoles);
      userRoles = Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      userRoles = sessionRoles.split(',').map(role => role.trim());
    }
  }

  const validRoles = userRoles.filter(role => role in roleLevels);

  if (validRoles.length === 0) {
    return { highestRole: null, level: null };
  }

  const highestRole = validRoles.reduce((prev, curr) =>
    roleLevels[curr] < roleLevels[prev] ? curr : prev,
    validRoles[0]
  );

  return {
    highestRole, // Return the highest when login time after that show current login role
    level: roleLevels[highestRole],
  };
};
